var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',_vm._b({class:_vm.buttonClasses,attrs:{"href":_vm.href,"target":_vm.target,"role":"button"},on:{"click":_vm.handleClick}},'a',_vm.$attrs,false),[_vm._t("default")],2):_c('button',_vm._b({class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }